<template>
  <div>
    <v-dialog v-model="dialog" class="dialog-wrapper" width="75%" max-width="450px">
      <template v-slot:activator="{ on, attrs }">
        <!--
          <v-btn :color="$getColor('vuetifyColor1')" v-if="!fabButton"
           v-bind="attrs" v-on="on" text>
            <v-icon left v-if="icon"> {{icon}} </v-icon>
            {{title}}
          </v-btn>
        <v-btn elevation="0" fab small outlined dark v-bind="attrs" v-on="on" v-if="fabButton">
            <v-icon :color="$getColor('vuetifyColor1')">chat</v-icon>
          </v-btn>
         -->
        <selection-button title="Añadir comentario" v-on="on" v-bind="attrs" enabled v-on:click.native="dialog = true" />
      </template>
      <v-card class="dialog-box">
        <v-card-title>
          <span class="text-h5 mb-2">{{ title }}</span>
        </v-card-title>
        <v-card-text class="pb-0">
          <div class="input-field">
            <label class="input-field--label">Usuario: </label>
            <v-text-field solo dense flat color="black" label="Usuario" v-model="adminUser" disabled
              hide-details></v-text-field>
          </div>
          <div class="input-field">
            <label class="input-field--label">Añadir Comentario: </label>
            <v-textarea  height="100%" hide-details outlined  flat color="black" label="Comentario" placeholder="Escribe tu comentario aquí..."
              v-model="description" required></v-textarea>
          </div>
        </v-card-text>
        <v-card-actions>
          <div class="navigation-buttons">
            <primary-button appearance="text" text="Cancelar" size="small" v-on:click.native="dialog = false" />
            <primary-button appearance="solid" text="Enviar" size="small" @click.native="addComment()" :enabled="description && description.trim() !== ''"  />
          </div>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import authHeader from '@/services/auth-header';
import authService from '@/services/auth.service';
import SelectionButton from '@/components/Buttons/SelectionButton.vue';
import PrimaryButton from '@/components/Buttons/PrimaryButton.vue';

const axios = require('axios');

export default {
  name: 'AddChatComment',
  props: {
    fabButton: {
      type: Boolean,
      default: true,
    },
    title: {
      type: String,
      default: '',
    },
    icon: {
      type: String,
      default: null,
    },
    affiliateId: {
      type: String,
      default: null,
    },
    affiliateEmail: {
      type: String,
      default: null,
    },
    admin: {
      type: String,
      default: '0',
    },
  },
  data() {
    return {
      name: null,
      description: null,
      date: new Date().toISOString().split('T')[0],
      dialog: false,
    };
  },
  components: {
    SelectionButton,
    PrimaryButton,
  },
  methods: {
    addComment() {
      axios
        .post(
          `${process.env.VUE_APP_API_URL}chatComment/`,
          {
            description: this.description,
            creationTime: this.date,
            affiliateTo: this.affiliateId,
            emailTo: this.affiliateEmail,
            affiliateFrom: null,
            emailFrom: authService.getDecodedJwtToken(this.$store.state.auth.user).sub,
            admin: true,
          },
          { headers: authHeader() },
        )
        .then(() => {
          this.$router.go();
        });
    },
  },
  computed: {
    adminUser() {
      return `${authService.getDecodedJwtToken(this.$store.state.auth.user).sub} ( ${this.date} )`;
    },
    affiliateFrom() {
      if (authService.getDecodedJwtToken(this.$store.state.auth.user).affiliate) {
        return authService.getDecodedJwtToken(this.$store.state.auth.user).affiliate;
      }
      return 'admin';
    },
  },
};
</script>

<style lang="scss" scoped>
.add_user-btn {
  max-width: 15em;
  margin-top: 0;
  margin-bottom: 1em;
}

.dialog-title {
  margin-bottom: 1em;

  span {
    color: var(--bodyColor);
  }
}

// .dialog-wrapper {
//   max-width: 250px;

//   .v-dialog--active {
//     max-width: 250px !important;
//   }
// }
.navigation-buttons {
  padding-top: 0;
  margin-top: calc(var(--base) * 2);
  margin-bottom: calc(var(--base) * 2);
}
</style>
